import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { ChangeEvent, useRef, useState } from 'react';

import { SurveyValueExcelFailure } from '../../../../../types/entity.types';

import { ARCHIVED, UPCOMING } from '../../../../../utils/constants';
import { getClassNames } from '../../../../../utils/util';

import FilePicker from '../../../../common/input/file-picker/FilePicker';
import SurveyUploadFailureModal from '../survey-upload-failure-modal/SurveyUploadFailureModal';

import { ReactComponent as UploadIcon } from '../../../../../resources/icons/upload.svg';

import '../accountability.scss';
import './accountability-survey.scss';

type Props = {
  status: string;
  uploadSurvey: (file: File, onError: (errors: SurveyValueExcelFailure[]) => void) => void;
};

const AccountabilitySurvey = ({ status, uploadSurvey }: Props) => {
  const [open, setOpen] = useState(true);
  const [surveyFileName, setSurveyFileName] = useState<string | undefined>(undefined);
  const [surveyUploadFailures, setSurveyUploadFailures] = useState<SurveyValueExcelFailure[] | undefined>(undefined);

  const fileRef = useRef<HTMLInputElement | null>(null);

  const handleFileInputClick = () => {
    if (status !== ARCHIVED) {
      fileRef.current?.click();
    }
  };

  const handleFileChange = async ({ target }: ChangeEvent<HTMLInputElement>) => {
    if (!target.files) return;

    const file = target.files[0]!;

    setSurveyFileName(file.name);

    uploadSurvey(file, (errors) => {
      setSurveyUploadFailures(errors);
    });
  };

  return (
    <div
      className={getClassNames('accountability__section', {
        closed: !open
      })}
      data-testid="accountability-survey"
    >
      <div className="accountability__section__header">
        <p>SURVEY ANSWERS</p>
        {!open && (
          <FontAwesomeIcon
            className="accountability__section__open-icon"
            icon={faPlus}
            onClick={() => setOpen(true)}
            data-testid="open-icon"
          />
        )}
        {open && (
          <FontAwesomeIcon
            className="accountability__section__close-icon"
            icon={faMinus}
            onClick={() => setOpen(false)}
            data-testid="close-icon"
          />
        )}
      </div>
      {open && (
        <div className="accountability-survey">
          <p>Upload .xlsx file:</p>
          <FilePicker
            fileType=".xlsx"
            triggerElement={
              <button
                className={getClassNames('accountability-survey__file-input', {
                  disabled: status === ARCHIVED || status === UPCOMING
                })}
                onClick={handleFileInputClick}
                disabled={status === ARCHIVED || status === UPCOMING}
              >
                <p>{surveyFileName ?? ''}</p>
                {status !== ARCHIVED && status !== UPCOMING && <UploadIcon data-testid="upload-icon" />}
              </button>
            }
            fileRef={fileRef}
            onChange={handleFileChange}
          />
        </div>
      )}

      <SurveyUploadFailureModal
        failures={surveyUploadFailures}
        show={!!surveyUploadFailures}
        close={() => setSurveyUploadFailures(undefined)}
      />
    </div>
  );
};

export default AccountabilitySurvey;
